<template>
  <div :style="defaultStyle">
    <trustflix-header />
    <main>
      <div id="trustflix">
        <!-- content -->
        <div :class="{
          'trustflix-content': true,
          shrink: sidenavIsOpen && !shopwindowIsLoading,
        }" ref="trustflixContent">
          <content-placeholders v-if="shopwindowIsLoading" class="row">
            <div class="box-banner">
              <div class="box-gradient"></div>

              <content-placeholders-img class="section-placeholder section-placeholder--header loading-dark" />
            </div>
            <br />
            <div class="box-content">
              <content-placeholders-img class="section-placeholder section-placeholder--progress loading-dark" />
              <br />
              <content-placeholders-img class="section-placeholder section-placeholder--dynamic loading-dark" />
            </div>
          </content-placeholders>

          <div class="row" v-else>

              <!-- video -->
              <div class="box-banner box-video" v-if="bannerType === 'Video' && videoBannerUrl">
              <YouTubePlayer
                :videoID=videoBannerUrl
                :image=image
                :primaryColor=primaryColor
              />
            </div>

             <!-- banners -->
            <div class="box-banner" v-else>
              <a :href="bannerUrl" target="_blank" :style="bannerUrl === 'javascript:;' && 'pointer-events: none'">
              <div class="box-gradient"></div>
              <!-- <img src="@/assets/images/drop.png" alt="" srcset="" /> -->
              <img v-lazy="loadImage(image)" alt="" :class="{'largeBanner': bannerType === 'LargeImage', 'smallBanner': bannerType === 'SmallImage'}"  />
              </a>
            </div>


            <!-- Dinamico -->
            <!-- Progress Section (position 1) -->
            <div v-if="progressPosition === 1">
              <ProgressSection :primaryColor="primaryColor" />
              <br />
            </div>

            <template v-for="(section, index) in sortedSections">
              <!-- Banner section -->
              <div
                v-if="section.type.toLowerCase() === 'banner' && section.bannerContent && section.bannerContent.length"
                :key="'BannerSection_' + section.id + '_' + index"
                class="trustflix-banner-section"
              >
                <a
                  v-if="section.bannerContent[0].link"
                  :href="section.bannerContent[0].link.startsWith('http') ? section.bannerContent[0].link : 'https://' + section.bannerContent[0].link"
                  target="_blank"
                >
                  <img
                    v-lazy="section.bannerContent[0].imagePathTemp || section.bannerContent[0].imagePath"
                    alt=""
                  />
                </a>
                <img
                  v-else
                  v-lazy="section.bannerContent[0].imagePathTemp || section.bannerContent[0].imagePath"
                  alt=""
                />
              </div>

              <!-- Dynamic section -->
              <div
                v-else-if="section.type.toLowerCase() === 'dynamic'"
                class="trustflix-dynamic-section"
                :key="'DynamicSection_' + section.id + '_' + index"
              >
                <DynamicSection :section="section" @clickBuyable="swipeBuySectionTo" />

                <!-- Progress Section (positions 2 and 3) -->
                <div v-if="progressPosition > 0 && progressPosition === index + 2">
                  <ProgressSection :primaryColor="primaryColor" />
                  <br />
                </div>
              </div>
            </template>
            <!-- Vendas -->
            <BuySection v-if="hasBuySection" ref="buySection" title="Mais vendidos" sub="Lançamento">
              <i class="material-icons" icon-color slot="icon">local_offer</i>
            </BuySection>
          </div>
        </div>
      </div>
      <!-- <div class="hidden-dot">
        <a href="javascript:;" @click="enableChatBot()">.</a>
      </div> -->
    </main>
  </div>
</template>

<script>
import ProgressSection from "@/components/Trustflix/ProgressSection";
import DynamicSection from "@/components/Trustflix/DynamicSection";
import BuySection from "@/components/Trustflix/BuySection";
import CourseBox from "@/components/MyCoursesCourseBox";
import { mapState, mapGetters } from "vuex";
import TrustflixHeader from "@/layout/TrustflixHeader.vue";
import ProgressBar from "@/components/UI/ProgressBar";
import HeaderPoster from "@/assets/images/posters/evf-video.png";
import YouTubePlayer from "@/components/Trustflix/YouTubePlayer";
import shopWindow from "../../store/modules/shopWindow";
import learningObject from "../../store/modules/learningObject";
import { ShopWindowsService } from "@/services/shopWindow.service";
import { termsOfUseMixin } from "@/mixins/termsOfUseMixin";

export default {
  name: "Trustflix",
  mixins: [termsOfUseMixin],
  components: {
    CourseBox,
    ProgressSection,
    DynamicSection,
    BuySection,
    TrustflixHeader,
    ProgressBar,
    YouTubePlayer
  },
  computed: {
    ...mapState({
      primaryColor: (state) => state.shopWindow.primaryColor,
      image: (state) => state.shopWindow.image,
      sections: (state) => state.shopWindow.dynamicSections,
      isValid: (state) => state.shopWindow.isValid,
      sidenavIsOpen: (state) => state.config.sidenavIsOpen,
      agentId: (state) => state.shopWindow.agentId,
      agentImage: (state) => state.shopWindow.agentImage,
      enableHumanSupport: (state) => state.shopWindow.enableHumanSupport,
      humanSupportOptions: (state) => state.shopWindow.humanSupportOptions,
      humanSupportMessage: (state) => state.shopWindow.humanSupportMessage,
      currentEnroll: (state) => state.enroll.current,
      shopwindowId: (state) => state.shopWindow.id,
      enrolls: (state) => state.enroll.enrolls,
      learningObjectsEnrolls: (state) =>
        state.shopWindow.learningObjectsEnrolls,
    }),
    ...mapGetters({
      hasBuySection: "shopWindow/hasBuySection",
      shopwindowIsLoading: "shopWindow/isLoading",
    }),
    sortedSections() {
      return _.sortBy(this.sections, "sequence");
    },
  },
  data() {
    return {
      bannerType: "",
      bannerUrl: "",
      videoBannerUrl: "",
      titleFontSize: "",
      progressPosition: 0,
      hasCourseWithChatbotEnabled: false,
      defaultStyle: {
        "--primary-color": "#0D0D13",
        "--text-color": "#FFFFFF",
        "--title-font-size": "18px",
      },
    };
  },
  methods: {
    async init() {
      this.$store.dispatch("enroll/clearCurrentEnroll");
      this.setColors();

      this.$gtag.pageview({
        page_title: "trustflix",
        page_path: "/p/trustflix",
      });

      // Verifica se há shopWindowId válido, senão tenta fallback
      let currentShopWindowId = ShopWindowsService.getCurrentShopWindow();

      if (!ShopWindowsService.isValidShopWindowId(currentShopWindowId)) {
        // Fallback: tenta buscar dos enrolls do usuário
        const enrolls = this.$store.state.enroll.enrolls;
        const fallbackShopWindowId = ShopWindowsService.tryGetShopWindowIdFromEnrolls(enrolls);

        if (fallbackShopWindowId) {
          ShopWindowsService.setCurrentShopWindow({ id: fallbackShopWindowId });
          currentShopWindowId = fallbackShopWindowId;
        }
        // Se não encontrou fallback, continua mesmo assim para manter compatibilidade
        // O tratamento de erro no catch vai redirecionar se necessário
      }

      if (!await this.checkProducerTermsOfUse()) return await this.$router.push("/p/my-courses");

      try {
        await this.$store.dispatch(
          "shopWindow/getLearningObjectsEnrolls",
          this.$currentUser.studentId
        );


        // Habilita chatbot se houver enrolls na vitrine
        this.hasCourseWithChatbotEnabled = this.learningObjectsEnrolls && this.learningObjectsEnrolls.length > 0;

        const shopwindow = await this.$store.dispatch(
          "shopWindow/getCurrentFullGrid"
        );

        if (!shopwindow) {
          return this.navTo("/p/my-courses");
        }
        if (shopwindow.bannerType === 'Video' && shopwindow.videoBannerUrl) {
          this.videoBannerUrl = this.extractYouTubeVideoId(shopwindow.videoBannerUrl);
        }

        this.bannerType = shopwindow.bannerType;
        this.bannerUrl = shopwindow.bannerUrl || "javascript:;";
        this.titleFontSize = shopwindow.titleFontSize;
        this.progressPosition = shopwindow.progressPosition;


        this.setTitleFontSize();
        this.setColors();

        this.$updateTheme({
          darkTheme: true,
          primary: shopwindow.primaryColor,
          titleFontSize: shopwindow.titleFontSize,
          progressPosition: shopwindow.progressPosition,

        });
      } catch (error) {
        // Em caso de erro, redireciona para meus cursos
        console.error('Erro ao carregar Trustflix:', error);
        return this.navTo("/p/my-courses");
      }
    },
    extractYouTubeVideoId(url) {
      // Handles: watch?v=, youtu.be/, embed/, shorts/, live/
      const match = url.match(
        /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
      );
      return match ? match[1] : null;
    },
    async checkProducerTermsOfUse() {
      const shopWindowId = Number(ShopWindowsService.getCurrentShopWindow());
      const genericShopWindowEnroll = this.enrolls.find((enroll) => enroll.shopWindowId === shopWindowId);

      if (!genericShopWindowEnroll) return true;

      return await this.checkAndShowTermsModal({
        courseId: null,
        applicationId: genericShopWindowEnroll.applicationId,
        applicationUserId: genericShopWindowEnroll.applicationUserId,
      });
    },
    getTextColor(primaryColor) {
      const brightness = (R, G, B) => (R * 299 + G * 587 + B * 114) / 1000;
      const MAX_BRIGHTNESS = 123;

      const r = parseInt(primaryColor.slice(1, 3), 16);
      const g = parseInt(primaryColor.slice(3, 5), 16);
      const b = parseInt(primaryColor.slice(5, 7), 16);

      if (brightness(r, g, b) > MAX_BRIGHTNESS) return "#333333";
      return "#FFFFFF";
    },
    setColors() {
      if (!this.primaryColor) return;
      this.defaultStyle["--primary-color"] = this.primaryColor;
      this.defaultStyle["--text-color"] = this.getTextColor(this.primaryColor);
    },
    setTitleFontSize() {
      if (!this.titleFontSize) return;
      this.defaultStyle["--title-font-size"] = this.titleFontSize + "px";
    },
    loadImage(image) {
      return {
        src: image || HeaderPoster,
        loading: HeaderPoster,
        error: HeaderPoster,
      };
    },
    swipeBuySectionTo(courseId) {
      const buySection = this.$refs.buySection;
      if (buySection) buySection.swipeTo(courseId);
    },
    navTo(path) {
      if (this.isPreview) return;

      if (path === "/p/my-courses") {
        this.$updateTheme({
          darkTheme: false,
          primary: "#0564b1",
          secondary: "#ffffff",
        });
      }

      this.$router.push(path);
    },
    async checkCoursesChatbotSettings() {
      try {
        if (!this.learningObjectsEnrolls || this.learningObjectsEnrolls.length === 0) {
          this.hasCourseWithChatbotEnabled = false;
          return;
        }

        // Obtém os enrolls únicos (evita duplicatas)
        const uniqueEnrolls = this.learningObjectsEnrolls.reduce((acc, current) => {
          const exists = acc.find(item => item.enrollId === current.enrollId);
          if (!exists) {
            acc.push(current);
          }
          return acc;
        }, []);

        // Busca as configurações de cada curso e faz fallback para enableIA se necessário
        const settingsPromises = uniqueEnrolls.map(async (enroll) => {
          try {
            const response = await ConfigService.getCourseSettings(enroll.courseId);

            // Se retornar 204 (No Content) ou 200 com data vazio, usa enableIA do enroll
            if (response.status === 204 || !response.data || response.data === '') {
              // Precisa buscar o enroll completo para obter as settings
              const enrollData = await this.$store.dispatch("enroll/getEnroll", enroll.enrollId);
              return enrollData?.settings?.enableIA || false;
            }

            return response.data?.enableChatBot || false;
          } catch (error) {
            // Em caso de erro, tenta usar enableIA do enroll
            try {
              const enrollData = await this.$store.dispatch("enroll/getEnroll", enroll.enrollId);
              return enrollData?.settings?.enableIA || false;
            } catch {
              return false;
            }
          }
        });

        const settingsResults = await Promise.all(settingsPromises);

        // Verifica se pelo menos um curso tem chatbot habilitado
        this.hasCourseWithChatbotEnabled = settingsResults.some(enabled => enabled === true);
      } catch (error) {
        console.error('Erro ao verificar configurações dos cursos:', error);
        this.hasCourseWithChatbotEnabled = false;
      }
    },
    async enableChatBot() {
      // Verifica primeiro se algum curso da vitrine tem chatbot habilitado
      if (!this.hasCourseWithChatbotEnabled) return;

      if (!this.agentId) return;
      var agentImage = this.agentImage;
      if (agentImage && !agentImage.startsWith("http")) {
        agentImage = `${process.env.VUE_APP_CDN_URL}` + agentImage;
      }
      await window.enableChatBot(
        this.agentId,
        agentImage,
        this.enableHumanSupport,
        this.humanSupportOptions,
        this.humanSupportMessage,
        null,
        this.$currentUser,
        this.shopwindowId,
        this.$profilePic
      );
    },
    async navigateToClassFromBubble(eventData) {
      try {
        var learningObjectsEnrolls = this.learningObjectsEnrolls;
        var enrollId = null;
        const learningObject =
          learningObjectsEnrolls &&
          learningObjectsEnrolls.find(
            (obj) => obj.learningObjectId === +eventData.detail.source.custom_id
          );
        if (learningObject) {
          enrollId = learningObject.enrollId;
        }
        await this.$router.push({
          name: "class",
          params: {
            enrollId: enrollId,
            id: +eventData.detail.source.custom_id,
          },
        });
        await window.minimizeChatBot();
      } catch (error) {
        console.error(error);
        this.$store.commit("toast/NEW", {
          type: "warn",
          message: "Ops! Não foi possível navegar para esta aula.",
        });
      }
    },
  },
  async mounted() {
    this.init();
    window.addEventListener("source-click", this.navigateToClassFromBubble);
    //await this.enableChatBot();
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("source-click", this.navigateToClassFromBubble);
    next();
  },
  watch: {
    agentId: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.enableChatBot();
        }
      },
    },
    sections(sects) {
      if (!sects.length && !this.isValid) this.navTo("/p/my-courses");
    },
  },
};
</script>

<style scoped lang="scss">
#app {
  @font-face {
    font-family: "Material Icons";
    font-display: block;
  }

  header,
  header nav,
  main,
  footer {
    background-color: rgb(0, 0, 0) !important;
  }

  #trustflix {
    display: flex;
    min-height: 100vh;
  }

  .trustflix-content {
    width: 100%;

    .box-content {
      background: rgb(0, 0, 0);
      padding: 15px;

      .content-title {
        font-weight: 600;
        border-left: 3px solid var(--primary-color);
        padding-left: 20px;
        font-size: var(--title-font-size) !important;
      }

      .box-trustflix-itens {
        width: 100%;
        height: 300px;
        background: rgb(0, 0, 0);
        overflow: hidden;
        margin: 10px 0;
        // border: 1px solid red;
        display: flex;
        flex-direction: row;
        align-items: center;

        .trustflix-item {
          margin-right: 10px;
          // border: 1px solid rgb(106, 255, 0);
          border-radius: 20px;
          width: 220px;
          height: 100%;
          overflow: hidden;
          // padding: 5px;

          .item-img {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          img {
            object-fit: contain;
          }
        }
      }
    }

    .box-main {
      width: 20% !important;
      height: 200px !important;
    }

    .box-course {
      height: 200px !important;

      .box-img img {
        max-width: 100%;
        height: auto;
      }
    }

    .box-banner {
      width: 100%;
      // max-height: 400px;
      overflow: hidden;
      position: relative;

      &.box-video{
        height: 75vh !important;

      }

      .box-gradient {
        z-index: 1;
        width: 100%;
        height: 100%;
        position: absolute;
         background: linear-gradient(
           180deg,
           rgba(0, 0, 0, 0) 50%,
           rgba(0, 0, 0, 1) 99%
         );
        }

      .box-gradient-video{
        background:  linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(9,9,121,0) 25%, rgba(4,4,54,0) 75%, rgba(0,0,0,1) 80%);
        background: linear-gradient(180deg,
            rgba(0, 0, 0, 0) 50%,
            rgba(0, 0, 0, 1) 99%);
      }

      img {
        border-style: none;
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-width: 100%;
          &.smallBanner{
            max-height: 400px;
          }

          &.largeBanner{
            max-height: 600px;
          }
      }
    }

    .trustflix-banner-section {
      margin: 8px 0;
      width: 100%;

      a {
        display: block;
        width: 100%;
      }

      img {
        display: block;
        width: 100%;
        max-height: 400px;
        object-fit: cover;
      }
    }

    .section-placeholder {
      border-radius: 20px;

      &.section-placeholder--progress {
        height: 286px;
      }

      &.section-placeholder--dynamic {
        height: 630px;
      }

      &.section-placeholder--header {
        border-radius: 0;
        height: 300px;
      }
    }

    transition: border 300ms ease;
    border-left: 0 solid #0d0d13;

    @media screen and (min-width: 1300px) {
      &.shrink {
        // border-left-width: 300px;
        border-left-width: 260px;
        transition: border 320ms ease;
      }
    }
  }
}
</style>
